// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h5yxVAQIi_sK4hEQX2mM {
  width: 100%;
}

.v4MpyZpFr_76hGqVqHik {
  display: flex;
  align-items: center;
}

.OkVqSX3nd7hDbia3_YAH {
  display: flex;
  justify-content: space-between;
}

.gyTB4R_oRUsQ12gbsl_i {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.75rem;
}

.Np4a0AQdyWJjuMbJbuTx {
  font-size: 1rem;
  padding: 0.5rem;
}

.ugQHL4Gg2UJZ8z6vKcRc {
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderMenuContentFooterAccordionItem/HeaderMenuContentFooterAccordionItem.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAW;EACX,cAAY;EACZ,qBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAY;AACd;;AAEA;EACE,mBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".wrapper {\n  width: 100%;\n}\n\n.collapsePanel {\n  display: flex;\n  align-items: center;\n}\n\n.itemContent {\n  display: flex;\n  justify-content: space-between;\n}\n\n.itemIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n\n.accordionItem {\n  font-size: 16px;\n  padding: 8px;\n}\n\n.accordionItems {\n  padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `h5yxVAQIi_sK4hEQX2mM`,
	"collapsePanel": `v4MpyZpFr_76hGqVqHik`,
	"itemContent": `OkVqSX3nd7hDbia3_YAH`,
	"itemIcon": `gyTB4R_oRUsQ12gbsl_i`,
	"accordionItem": `Np4a0AQdyWJjuMbJbuTx`,
	"accordionItems": `ugQHL4Gg2UJZ8z6vKcRc`
};
export default ___CSS_LOADER_EXPORT___;
